import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthButtons = ({ onNavigate }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    if (onNavigate) {
      // This means we're in the main app context
      onNavigate('login');
    } else {
      // This means we're in a router context, navigate to home and trigger login
      navigate('/?auth=login');
    }
  };

  const handleSignUp = () => {
    if (onNavigate) {
      // This means we're in the main app context
      onNavigate('register');
    } else {
      // This means we're in a router context, navigate to home and trigger signup
      navigate('/?auth=register');
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={handleLogin}
        className="px-4 py-2 rounded-xl text-sm font-medium text-gray-700 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      >
        Login
      </button>
      <button
        type="button"
        onClick={handleSignUp}
        className="px-4 py-2 rounded-xl text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors shadow-sm"
      >
        Sign Up
      </button>
    </div>
  );
};

export default AuthButtons;
